var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 28,
    viewBox: "0 0 32 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 28,
    rx: 8,
    fill: "#61C478",
    fillOpacity: 0.15
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2967_449)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.5303 8.42953C14.5303 7.56797 15.2312 6.86703 16.0928 6.86703H16.6335L16.4704 6.41359C16.3787 6.15859 16.1384 6 15.8823 6C15.8113 6 15.7391 6.01219 15.6685 6.03788L10.2044 8.02666C9.87954 8.14491 9.71235 8.50437 9.83129 8.82897L10.12 9.61703H14.5303V8.42953Z",
    fill: "#248C3C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0938 7.8045C15.7486 7.8045 15.4688 8.08432 15.4688 8.4295V9.617H20.9375V8.4295C20.9375 8.08432 20.6577 7.8045 20.3125 7.8045H16.0938Z",
    fill: "#248C3C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5938 18.6326H20.4062C19.1139 18.6326 18.0625 17.5812 18.0625 16.2889C18.0625 14.9965 19.1139 13.9451 20.4062 13.9451H22.5938V11.8045C22.5938 11.1142 22.0341 10.5545 21.3438 10.5545H9.25C8.55966 10.5545 8 11.1142 8 11.8045V20.75C8 21.4403 8.55966 22 9.25 22H21.3438C22.0341 22 22.5938 21.4403 22.5938 20.75V18.6326Z",
    fill: "#248C3C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5312 14.8826H20.4062C19.6308 14.8826 19 15.5135 19 16.2889C19 17.0643 19.6308 17.6951 20.4062 17.6951H23.5312C23.7897 17.6951 24 17.4848 24 17.2264V15.3514C24 15.0929 23.7897 14.8826 23.5312 14.8826ZM20.4062 16.7576C20.1474 16.7576 19.9375 16.5478 19.9375 16.2889C19.9375 16.03 20.1474 15.8201 20.4062 15.8201C20.6651 15.8201 20.875 16.03 20.875 16.2889C20.875 16.5478 20.6651 16.7576 20.4062 16.7576Z",
    fill: "#248C3C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2967_449"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(8 6)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.bfc25a2b78a7c7a9896103bdff4ca686.svg";
export { ForwardRef as ReactComponent };